import { Link } from "react-router-dom";
import LogoutButton from "../components/LogoutButton";

export default function Sidebar() {
  // const logout = () => {
  //   // 1. Remove tokens
  //   localStorage.removeItem("dashboard-web_access_token");
  //   localStorage.removeItem("dashboard-web_refresh_token");

  //   // 2. Optional: Remove PKCE or other local states
  //   localStorage.removeItem("pkce_verifier");

  //   // 3. Redirect to Identity login page
  //   window.location.href = "https://localhost:5200/signin";
  // };

  return (
    <div
      style={{
        width: "240px",
        background: "#eee",
        padding: "20px",
        height: "100vh",
      }}
    >
      
      <h1>Dashboard</h1>
      <ul>
        <li>
          <Link to="/">Overview</Link>
        </li>
        <li>
          <Link to="/clients">Applications</Link>
        </li>
        <li>
          <Link to="/users">Users</Link>
        </li>
        <li>
          <Link to="/settings">Settings</Link>
        </li>
        <li>
          <Link to="/docs">Documents</Link>
        </li>
      </ul>

      <LogoutButton />
    </div>
  );
}